const Backdrop = ({ children, hide = () => {}, open, fitToParent = false }) =>
	open ? (
		<div
			style={{
				position: fitToParent ? "absolute" : "fixed",
				height: fitToParent ? "100%" : "100vh",
				width: fitToParent ? "100%" : "100vw",
				top: 0,
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				left: 0,
				backgroundColor: "rgba(0, 0, 0, 0.55)",
				zIndex: 3000,
				borderRadius: 5,
			}}
			onClick={(e) => {
				e.stopPropagation();
				hide();
			}}
		>
			{children}
		</div>
	) : null;

export default Backdrop;
